import { render, staticRenderFns } from "./TicketingPaymentMethod.vue?vue&type=template&id=3bf6083a"
import script from "./TicketingPaymentMethod.vue?vue&type=script&lang=ts"
export * from "./TicketingPaymentMethod.vue?vue&type=script&lang=ts"
import style0 from "./TicketingPaymentMethod.vue?vue&type=style&index=0&id=3bf6083a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports